import { useI18N } from '../../libraries/i18n/hook'
import PageHeading from '../components/layout/PageHeading'
import { CoursesExplorer } from '../containers/content/courses'

const CoursesPage = () => {
  const { t } = useI18N()
  return (
    <div>
      <PageHeading>{t('courses.title')}</PageHeading>
      <CoursesExplorer />
    </div>
  )
}

export default CoursesPage
